var Footer;
(function (Footer) {
    if (window.innerWidth < 768) {
        const $footers = document.querySelectorAll('#footer');
        if ($footers) {
            $footers.forEach($footer => {
                const $subFooters = $footer.querySelectorAll('.menu-item, .country-switcher');
                if ($subFooters) {
                    $subFooters.forEach($subFooter => {
                        const $title = $subFooter.querySelector('h2, .title');
                        $title.addEventListener(('click'), () => {
                            $subFooter.classList.toggle('clicked');
                            $subFooters.forEach($subFooter => {
                                if (!$subFooter.classList.contains('clicked')) {
                                    $subFooter.classList.remove('open');
                                }
                            });
                            if ($subFooter.classList.contains('clicked') && $subFooter.classList.contains('open')) {
                                $subFooter.classList.remove('open');
                            }
                            else {
                                $subFooter.classList.add('open');
                            }
                            $subFooter.classList.remove('clicked');
                        });
                    });
                }
            });
        }
    }
})(Footer || (Footer = {}));
